/* eslint-disable no-console */
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import getListeners from './ListenersCanvas';
import {CanvasListenersType, DrawingSubstrateType, LoadType} from '../types';

export class CreateScene implements LoadType {
  static currentInstance: CreateScene;
  static ASPECT = 2;
  static playAnimation = false;
  static heightCamera = 200;
  static count = 0;

  uuid = '';

  initialisationScene = false;
  scene: THREE.Scene;
  camera: THREE.OrthographicCamera | undefined;
  renderer: THREE.WebGL1Renderer;
  controls: OrbitControls | undefined | null;
  gridHelper: THREE.GridHelper | undefined;
  domElementListeners: CanvasListenersType | undefined;
  widthCanvas = 600;
  heightCanvas = 600;
  drawingSubstrate:  DrawingSubstrateType | null = null;
  private isScreenshot = false;
  private screenshotData?: string;

  constructor() {
    this.scene = new THREE.Scene();
    this.renderer = new THREE.WebGL1Renderer({ antialias: true });
    this.initialisationScene = false;
    CreateScene.currentInstance = this;
  }

  initScene(contCanvas: HTMLDivElement): void {
    console.log('%c[Init Constructor Scene]!', 'color: #ff00ff');
    const box = contCanvas.getBoundingClientRect();
    this.widthCanvas = box.width;
    this.heightCanvas = box.height;
    if (!this.initialisationScene) {
      this.initialisationScene = true;
      this.camera = this.addCameraScene(box);

      // this.camera = new THREE.OrthographicCamera(
      //   box.width / -CreateScene.ASPECT,
      //   box.width / CreateScene.ASPECT,
      //   box.height / CreateScene.ASPECT,
      //   box.height / -CreateScene.ASPECT,
      //   0.1,
      //   1000
      // );

      // this.scene.add(this.camera);
      // this.camera.position.copy(new THREE.Vector3(0, CreateScene.heightCamera, 0));
      // this.camera.lookAt(new THREE.Vector3(0, 0, 0));
      // this.camera.zoom = 100;
      // this.camera.updateProjectionMatrix();
      this.renderer.setClearColor('#ffffff');

      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.renderer.setSize(this.widthCanvas, this.heightCanvas);
      this.renderer.domElement.setAttribute('id', 'canvas_scheme_constructor');

      // this.renderer.domElement.addEventListener("contextmenu", ( e )=> { e.preventDefault(); return false; } );

      contCanvas.innerHTML = '';
      contCanvas.appendChild(this.renderer.domElement);

      this.domElementListeners = getListeners({
        camera: this.camera,
        element: this.renderer.domElement,
        heightContainer: box.height,
        widthContainer: box.width,
      });

      this.addGridHelpers();
      this.uuid = THREE.MathUtils.generateUUID();
    }
    /*else {
      if (this.camera) {
        this.scene.remove(this.camera);
      }
      this.camera = this.addCameraScene(box);
      this.renderer.setSize(this.widthCanvas, this.heightCanvas);
      contCanvas.innerHTML = '';
      contCanvas.appendChild(this.renderer.domElement);
      this.domElementListeners = getListeners({
        camera: this.camera,
        element: this.renderer.domElement,
        heightContainer: box.height,
        widthContainer: box.width,
      });
    }*/

    this.activate();
  }
  addControls() {
    if (this.camera) {
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);
      /*this.controls.maxPolarAngle = 2.1;
      this.controls.minPolarAngle = 0.75;*/
      this.controls.maxZoom = 1500;
      this.controls.minZoom = 30;
      /*this.controls.autoRotateSpeed = 30;
      this.controls.enablePan = false;*/
      this.controls.enableKeys = false;
      this.controls.enableRotate = false;
      this.controls.touches.ONE = THREE.TOUCH.PAN;
      this.controls.addEventListener('change', updateCameraZoom);
    }
  }
  removeControls() {
    if (this.controls) {
      this.controls.removeEventListener('change', updateCameraZoom);
      this.controls.dispose();
      this.controls = null;
    }
  }
  addGridHelpers() {
    this.gridHelper = new THREE.GridHelper(100, 200, '#343434', '#cecece');
    this.gridHelper.position.y = -0.1;
    this.scene.add(this.gridHelper);

    // const points = [new THREE.Vector3(-10, 0, 0), new THREE.Vector3(-10, 0, -150)];
    // const geometry = new THREE.BufferGeometry().setFromPoints(points);
    // const material = new THREE.LineBasicMaterial({ color: 0xff00ff });
    // const line = new THREE.Line(geometry, material);
    // this.scene.add(line);
  }
  removeGridHelpers() {
    if (this.gridHelper) {
      this.scene.remove(this.gridHelper);
      this.gridHelper = undefined;
    }
  }
  activate() {
    if (this.domElementListeners) {
      this.domElementListeners.activateListeners();
    }
    if (!this.controls) {
      this.addControls();
    }

    if (!CreateScene.playAnimation) {
      CreateScene.playAnimation = true;
      CreateScene.animate();
    }
  }
  deactivate() {
    CreateScene.playAnimation = false;
    this.initialisationScene = false;
    if (this.domElementListeners) {
      this.domElementListeners.deactivateListeners();
    }
    this.removeControls();
    this.removeGridHelpers()
  }
  getScreenshot(): Promise<string | undefined> {
    this.isScreenshot = true;
    if (this?.gridHelper) {
      this.gridHelper.visible = false;
    }
    if (this.drawingSubstrate) {
      this.drawingSubstrate.visible = false;
    }
    // return CreateScene.currentInstance.screenshotData;
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(CreateScene.currentInstance.screenshotData);
      }, 300);
    });
  }
  clearScreenshotData() {
    CreateScene.currentInstance.screenshotData = undefined;
  }

  private addCameraScene(box: DOMRect): THREE.OrthographicCamera {
    const camera = new THREE.OrthographicCamera(
      box.width / -CreateScene.ASPECT,
      box.width / CreateScene.ASPECT,
      box.height / CreateScene.ASPECT,
      box.height / -CreateScene.ASPECT,
      0.1,
      1000
    );
    this.scene.add(camera);
    camera.position.copy(new THREE.Vector3(0, CreateScene.heightCamera, 0));
    camera.lookAt(new THREE.Vector3(0, 0, 0));
    camera.zoom = 100;
    camera.updateProjectionMatrix();
    return camera;
  }

  static animate() {
    if (CreateScene.playAnimation && CreateScene.currentInstance.camera) {
      requestAnimationFrame(CreateScene.animate);
      /*if (CreateScene.count === 60) {
        console.log('animate');
        CreateScene.count = 0;
      } else {
        CreateScene.count++;
      }*/
      CreateScene.currentInstance.renderer.render(
        CreateScene.currentInstance.scene,
        CreateScene.currentInstance.camera
      );
      if (CreateScene.currentInstance.isScreenshot) {
        CreateScene.currentInstance.isScreenshot = false;
        CreateScene.currentInstance.screenshotData =
          CreateScene.currentInstance.renderer.domElement.toDataURL();
        if (CreateScene.currentInstance?.gridHelper) {
          CreateScene.currentInstance.gridHelper.visible = true;
        }
        if (CreateScene.currentInstance?.drawingSubstrate) {
          CreateScene.currentInstance.drawingSubstrate.visible = true;
        }
      }
      CreateScene.currentInstance.controls?.update();
    }
  }
}
function updateCameraZoom() {
  // console.log('change', Load.camera?.zoom);
  // Load.camera?.updateProjectionMatrix();
}
